/**
 * @build0.ai/core/eslint-rules
 *
 * Shared ESLint rules for Build0 projects.
 * Prevents common React/Radix UI pitfalls and enforces best practices.
 */

import noEmptySelectItemValue from "./rules/no-empty-select-item-value.js";

export default {
  rules: {
    "no-empty-select-item-value": noEmptySelectItemValue,
  },
};
